import { styled } from 'styled-components';

import { cssBreakpoints, spacing } from '#/theme/theme';

export const SearchResultsHeaderHolder = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: ${spacing[24]};
`;

export const SearchResultsHeaderLeftSide = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const SearchResultsHeaderLeftSideSort = styled.div`
  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    display: none;
  }
`;

export const SearchResultsHeaderRightSide = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const SearchResultsHeaderPostAListingHolder = styled.div`
  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    display: none;
  }
`;
